import { createCrudSlice } from '../createCrudSlice';
import categoriesService from '@/services/categories.service';

const { reducer, thunks } = createCrudSlice('categories', categoriesService);
export const { fetchList: fetchCategories, createItem: createCategory, updateItem: updateCategory, deleteItem: deleteCategory } = thunks;
export default reducer;
